import React from 'react';
import { FilterOperator } from '../../interfaces/sessions';
import { FilterColumnProps } from './types';
import { FilterColumnTypes, getColumnType } from './cfg';
import { FixedSingleSelect } from '../Selectors/FixedSingleSelect';
import { SimplifiedSingleSelect } from '../Selectors/SimplifiedSingleSelect';

export const NUMERICAL_OPERATORS = [FilterOperator.EQ, FilterOperator.NEQ, FilterOperator.GT, FilterOperator.GE, FilterOperator.LT, FilterOperator.LE, FilterOperator.IN, FilterOperator.NIN]
export const DURATION_OPERATORS = [FilterOperator.EQ, FilterOperator.NEQ, FilterOperator.GT, FilterOperator.GE, FilterOperator.LT, FilterOperator.LE]
export const CATEGORICAL_OPERATORS = [FilterOperator.IN, FilterOperator.NIN]
export const TEXT_OPERATORS = [FilterOperator.EQ, FilterOperator.NEQ, FilterOperator.LIKE]
export const BOOLEAN_OPERATORS = [FilterOperator.EQ, FilterOperator.NEQ]
export const DATE_OPERATORS = [FilterOperator.EQ, FilterOperator.GT, FilterOperator.GE, FilterOperator.LT, FilterOperator.LE]

export function getOperators(columnType: FilterColumnTypes) {
  switch (columnType) {
    case FilterColumnTypes.NUMERICAL: return NUMERICAL_OPERATORS
    case FilterColumnTypes.DURATION: return DURATION_OPERATORS
    case FilterColumnTypes.CATEGORICAL: return CATEGORICAL_OPERATORS
    case FilterColumnTypes.BOOLEAN: return BOOLEAN_OPERATORS
    case FilterColumnTypes.BOOLEAN_NUMERICAL: return BOOLEAN_OPERATORS
    case FilterColumnTypes.DATE: return DATE_OPERATORS
    default: return []
  }
}

const FILTER_OPERATOR_TO_STRING = { 
  [FilterOperator.EQ]: 'Equals',
  [FilterOperator.NEQ]: 'Not equals',
  [FilterOperator.GT]: 'Greater than',
  [FilterOperator.GE]: 'Greater than or equal to',
  [FilterOperator.LT]: 'Less than',
  [FilterOperator.LE]: 'Less than or equal to',
  [FilterOperator.IN]: 'In',
  [FilterOperator.NIN]: 'Not in',
  [FilterOperator.LIKE]: 'Like',
}

export function OperatorSelector({ value, onChange, useFixed = false }: FilterColumnProps) {
  const operator = value.operator;
  const column = value.column_name;

  const columnType = getColumnType(column)
  const operators = getOperators(columnType)

  if (!operators.length) return null

  // Convert operators to options format for FixedSingleSelect
  const operatorOptions = operators.map(op => ({
    value: op,
    label: FILTER_OPERATOR_TO_STRING[op]
  }));

  const SelectComponent = useFixed ? FixedSingleSelect : SimplifiedSingleSelect;

  return (
    <div className="flex-shrink-0 w-36">
    <SelectComponent
      options={operatorOptions}
      value={operator || null}
      onChange={(selectedOperator) => {
        if (selectedOperator) {
          onChange({...value, operator: selectedOperator as FilterOperator})
        }
      }}
        placeholder="Select operator..."
      />
    </div>
  );
} 